/* KÖRVONAL — Home v2 behaviour (docs/korvonal-home-v2-plan.md). Small on purpose:
   which blocks show is pure CSS keyed on <html data-kv-aud>, set before paint by
   snippets/kv-home-aud.liquid. This file only
     1. moves that attribute when a "Kinek keresel?" pill is pressed (hero or
        decks — one state for the whole page), remembers it for the tab and
        writes it into the address bar as ?for=<slug>;
     2. keeps every pill's aria-pressed in step, and the pressed pill in view in a scrolling row;
     3. adds a product to the cart and opens the theme's cart drawer (the same
        path as the PDP action band, kv-sg-action-body);
     4. opens the rest of a deck grid on phones ("Mutass többet").
   Pill and button clicks are measured by korvonal-home-events (home_click). */
(function () {
  "use strict";
  var root = document.documentElement;

  function current() { return root.getAttribute("data-kv-aud") || "all"; }

  function sync() {
    var aud = current();
    Array.prototype.forEach.call(document.querySelectorAll("[data-kvh-pick]"), function (b) {
      b.setAttribute("aria-pressed", String(b.getAttribute("data-kvh-pick") === aud));
    });
    Array.prototype.forEach.call(document.querySelectorAll(".kvd-grid.is-open"), function (g) { g.classList.remove("is-open"); });
    Array.prototype.forEach.call(document.querySelectorAll("[data-kvd-more]"), function (b) { b.hidden = false; });
    // phones: a pill row scrolls sideways, so a page opened on Csapatnak (or picked in the
    // other row) would hide its pressed pill; bring it to the middle of the row
    Array.prototype.forEach.call(document.querySelectorAll(".kvh-pills"), function (row) {
      var on = row.querySelector('[aria-pressed="true"]');
      if (!on || row.scrollWidth <= row.clientWidth) return;
      var r = row.getBoundingClientRect(), p = on.getBoundingClientRect();
      if (p.left < r.left || p.right > r.right) row.scrollLeft += p.left - r.left - (r.width - p.width) / 2;
    });
  }

  // The pill's audience goes into the address bar as ?for=<slug>, so the current view is
  // always a link someone can copy (operator, 2026-10-01). replaceState: no extra history step.
  // Hungarian slugs on the HU home; the English keys (also read by kv-home-aud) everywhere else.
  var SLUG = /^hu/.test(root.lang || "hu")
    ? { partner: "parok", friends: "baratok", family: "csalad", kids: "gyerek", self: "magad", team: "csapat" }
    : { partner: "couples", friends: "friends", family: "family", kids: "kids", self: "self", team: "team" };
  function writeUrl(aud) {
    try {
      var u = new URL(location.href);
      if (SLUG[aud]) u.searchParams.set("for", SLUG[aud]); else u.searchParams.delete("for");
      history.replaceState(history.state, "", u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function pick(aud, from) {
    if (aud === "all") root.removeAttribute("data-kv-aud"); else root.setAttribute("data-kv-aud", aud);
    root.setAttribute("data-kv-aud-src", "pill");
    try { sessionStorage.setItem("kv_home_aud", aud); } catch (e) {}
    writeUrl(aud);
    sync();
    // a pill pressed in the hero leaves the hero in view; one pressed in the decks
    // header keeps that header in view (the grid above it can change height)
    if (from && from.closest("[data-kvd-top]")) {
      var top = from.closest("[data-kvd-top]").getBoundingClientRect().top;
      if (top < 0) from.closest("[data-kvd-top]").scrollIntoView({ block: "start" });
    }
  }

  document.addEventListener("click", function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t) return;
    var p = t.closest("[data-kvh-pick]");
    if (p) { ev.preventDefault(); pick(p.getAttribute("data-kvh-pick"), p); return; }
    var more = t.closest("[data-kvd-more]");
    if (more) {
      var grid = document.querySelector('.kvd__grids > .kvd-grid[data-aud="' + current() + '"]');
      if (grid) { grid.classList.add("is-open"); more.hidden = true; }
      return;
    }
    var add = t.closest("[data-kvh-add]");
    if (add) { ev.preventDefault(); addToCart(add); }
  });

  function openDrawer() {
    return fetch("?section_id=helper-cart")
      .then(function (r) { return r.text(); })
      .then(function (text) {
        if (typeof window.renderHelperCart === "function") window.renderHelperCart(text);
        var drawer = document.getElementById("site-cart-sidebar");
        if (drawer && typeof drawer.show === "function") drawer.show();
        else window.location.href = "/cart";
      });
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute("data-kvh-add")), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add " + r.status); return openDrawer(); })
      .catch(function () { btn.textContent = btn.getAttribute("data-err") || label; setTimeout(function () { btn.textContent = label; }, 2600); })
      .then(function () { btn.disabled = false; });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sync); else sync();
})();
